// Shared Chakra style prop objects for the confiscation requests view.

/** Table header cell props (Chakra Th). Color applied via useColorModeValue. */
export const HEAD_CELL = {
  borderColor: "transparent",
  fontSize: "10px",
  fontWeight: "700",
  letterSpacing: "0.5px",
  py: "12px",
};

/** Table body cell props (Chakra Td). */
export const BODY_CELL = {
  borderColor: "transparent",
  fontSize: "sm",
  py: "12px",
};
